import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { selectCurrentOperatorWarehouse } from '../features/operator/operatorUtils';
import { FlowUnavailable } from '../workspaces/operator/components/FlowUnavailable';

/**
 * Lets a flow's screens through only in a warehouse that allows it. With no
 * warehouse chosen it sends to Inicio, where it is chosen.
 *
 * When the server later says the flow was switched off, the context is asked
 * again and this gate follows it on its own.
 *
 * @param {object} props
 * @param {string} props.flow
 */
export const OperatorFlowGate = ({ flow }) => {
  const warehouse = useSelector(selectCurrentOperatorWarehouse);
  if (!warehouse) return <Navigate to="/dashboard" replace />;
  if (!warehouse.flows?.[flow]) return <FlowUnavailable flow={flow} warehouse={warehouse} />;
  return <Outlet />;
};
